
import { Vue, Options } from 'vue-class-component'
import { maska } from 'maska'
import { Prop } from 'vue-property-decorator'
import {
  IFlexMessageBox,
  IFlexMessageButton,
  IFlexMessageIcon,
  IFlexMessageImage,
  IFlexMessageText,
} from '@/utils/types'

@Options({
  components: {},
  directives: { maska },
  emits: ['update:modelValue'],
})
export default class Offset extends Vue {
  @Prop()
  modelValue!: IFlexMessageText | IFlexMessageBox | IFlexMessageButton | IFlexMessageImage | IFlexMessageIcon

  get value() {
    return this.modelValue
  }

  set value(value: IFlexMessageText | IFlexMessageBox | IFlexMessageButton | IFlexMessageImage | IFlexMessageIcon) {
    this.$emit('update:modelValue', value)
  }

  get offsetList() {
    return ['none', 'xs', 'sm', 'md', 'lg', 'xl', 'xxl']
  }

  offsetValidate(val) {
    if (!val) return true

    const isPxOrPercent = /^-?\d+(\.\d+)?(px|%)$/.test(val)
    const isKeyword = this.offsetList.includes(val)
    return isPxOrPercent || isKeyword
  }
}
